@if (standaloneMode) {
  <app-header [showMenu]="true"></app-header>
}
<small class="debug">{{me}}</small>
@if (standaloneMode) {
  <div style="position: fixed; right: 20px" class="hide-xs">
    <app-local-diag [setLargeMode]="true"></app-local-diag>
    <app-theme-selector></app-theme-selector>
  </div>
}
@if (standaloneMode) {
  <a mat-button class="goBack" routerLink="/login">
    <mat-icon style="position: relative; top: -2px">keyboard_arrow_left</mat-icon>
    {{'account.back' | transloco}}
  </a>
}
<br/>
<br/>
<br/>
<div class="headingShop">
  <button class="butt" [ngClass]="{'selectedNav':selected === 'products'}" mat-button (click)="navigateTo('products')">
    <mat-icon>view_comfy</mat-icon>
    {{'general.products' | transloco}}
  </button>
  <mat-icon class="chevronRight">chevron_right</mat-icon>
  <button class="butt" [ngClass]="{'selectedNav':selected === 'list'}" mat-button (click)="navigateTo('cart')">
    <mat-icon>shopping_cart</mat-icon>
    {{'general.cart' | transloco}}
  </button>
  <mat-icon class="chevronRight">chevron_right</mat-icon>
  <button class="butt" [ngClass]="{'selectedNav':selected === 'checkout'}" mat-button (click)="navigateTo('checkout')">
    <mat-icon>outlined_flag</mat-icon>
    {{'general.checkout' | transloco}}
  </button>
</div>

